import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services';
import { AuthStore } from '../stores';
import { AuthResponse } from '../models';

export const authInterceptor = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authStore = inject(AuthStore);
  const authService = inject(AuthService);

  const isAuthUrl = request.url.endsWith('/api/auth/authenticate') || request.url.endsWith('/api/auth/refresh-token');
  const requireRefreshToken = request.url.endsWith('/api/auth/refresh-token');
  const requireAccessToken = !isAuthUrl && !request.url.endsWith('/api/auth/e5e6edd233a84dd09f5de7a2d8b884ca');

  if (requireAccessToken && authStore.accessToken()) {
    request = addToken(request, authStore.accessToken());
  }
  if (requireRefreshToken && authStore.refreshToken()) {
    request = addRefreshToken(request, authStore.refreshToken());
  }

  return next(request).pipe(
    catchError((error) => {
      if (!(error.status === 401 && !isAuthUrl && authStore.refreshToken())) {
        throw error;
      }

      return authService.refreshToken().pipe(
        switchMap((response: AuthResponse) => {
          request = addToken(request, response.accessToken);
          return next(request);
        }),
      );
    }),
  );
};

const addToken = (request: HttpRequest<any>, token: string | null): HttpRequest<any> => {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const addRefreshToken = (request: HttpRequest<any>, refreshToken: string | null): HttpRequest<any> => {
  return request.clone({
    setHeaders: {
      'X-Refresh-Token': refreshToken ?? '',
    },
  });
};
